import {
	ChangeDetectionStrategy,
	Component,
	input,
	InputSignal,
	OnDestroy,
	signal,
	WritableSignal,
} from '@angular/core'
import { TuiDropdown } from '@taiga-ui/core'
import { TranslatePipe } from '@ngx-translate/core'
import { Subject } from 'rxjs'
import { OrderInterface } from '@modules/orders-module/interfaces/order.interface'
import { DropdownVariantEnum } from '@shared/enums/dropdown-variant.enum'
import { OrderInfoCardComponent } from '../../../actions/order-info-card/order-info-card.component'
import { ClickOutsideDirective } from '@shared/directives/click-outside.directive'
import { ButtonComponent } from '@shared/components/ui-kit/button/button.component'

@Component({
	selector: 'app-canceled-orders-actions',
	templateUrl: './canceled-orders-actions.component.html',
	styleUrl: './canceled-orders-actions.component.scss',
	imports: [OrderInfoCardComponent, TuiDropdown, TranslatePipe, ClickOutsideDirective, ButtonComponent],
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CanceledOrdersActionsComponent implements OnDestroy {
	protected readonly dropdownVariantEnum: typeof DropdownVariantEnum = DropdownVariantEnum

	public order: InputSignal<OrderInterface | null> = input<OrderInterface | null>(null)

	private _destroy$: Subject<void> = new Subject()

	protected openedDropdown: WritableSignal<DropdownVariantEnum | null> = signal(null)

	protected toggleDropdown(dropdown: DropdownVariantEnum | null): void {
		if (this.openedDropdown() === dropdown) {
			this.openedDropdown.set(null)
		} else {
			this.openedDropdown.set(dropdown)
		}
	}

	protected onClickOutside(): void {
		this.openedDropdown.set(null)
	}

	ngOnDestroy(): void {
		this._destroy$.next()
		this._destroy$.complete()
	}
}
